<template>
    <div class="slider">
        <i class="fas fa-chevron-left" @click="previousSlide"></i>
        <i class="fas fa-chevron-right" @click="nextSlide"></i>
        <div class="bar">
            <transition name="fadeMenuOverlay" mode="out-in">
                <h3 :key="activeSlideData.id">{{ activeSlideData.description }}</h3>
            </transition>
            <a :key="activeSlideData.id" :href="activeSlideData.action_url">{{ activeSlideData.action_title }}</a>
        </div>
        <div class="slides" :style="{'transform': 'translateX('+ index +'%)', 'transition' : transition}">
            <img v-for="slide in slides" :key="slide.id" :src="'/games/static/slides/'+slide.image_url" :alt="slide.description" draggable="false" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Slider',
    data() {
        return {
            slides: [],
            index: 0,
            activeSlideIndex: 1,
            activeSlideData: {},
            transition: 'transform 0.2s ease',
            slideTimer: null
        }
    },
    methods: {
        previousSlide() {
            clearInterval(this.slideTimer);
            
            if(this.index == 0) {
                this.transition = 'transform 0.4s ease';
                this.index = -25 * (this.slides.length - 1);
                this.activeSlideIndex = this.slides.length;
            } else {
                this.transition = 'transform 0.2s ease';
                this.index += 25;
                this.activeSlideIndex--;
            }

            this.slideTimer = setInterval(() => { this.nextSlide() }, 4000);
        },
        nextSlide() {
            clearInterval(this.slideTimer);

            if(this.index == -25 * (this.slides.length - 1)) {
                this.transition = 'transform 0.4s ease';
                this.index = 0;
                this.activeSlideIndex = 1;
            } else {
                this.transition = 'transform 0.2s ease';
                this.index -= 25;
                this.activeSlideIndex++;
            }

            this.slideTimer = setInterval(() => { this.nextSlide() }, 4000);
        },
        getSlides() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getSlides", formData)
            .then((response) => {
                if(response.data.length > 0) {
                    this.slides = response.data;
                    this.activeSlideData = this.slides.find(slide => slide.id == this.activeSlideIndex);
                }
            });
        }
    },
    mounted() {
        this.getSlides();

        this.slideTimer = setInterval(() => { this.nextSlide() }, 4000);
    },
    beforeDestroy() {
        clearInterval(this.slideTimer);
    },
    watch: {
        activeSlideIndex() {
            this.activeSlideData = this.slides.find(slide => slide.id == this.activeSlideIndex);
        }
    }
}
</script>

<style scoped src="@/assets/slider.css">
</style>